export default __webpack_public_path__ + "static/media/trickFasting.edb34c6d.svg";